import React, { useEffect, useMemo, useState } from 'react';
import styles from './HomeSlider.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import LazyVideo from '../../../../../atoms/lazyVideo/LazyVideo';
import Text from '../../../../../atoms/text/Text';
import useDeafModeAutoMute from '../../../../../../app/hooks/useDeafModeAutoMute';
import HtmlTag from '../../../../../molecule/htmlTag/HtmlTag';
import { setVolume } from '../../../../../../app/globals/slice/volume/VolumeState';
import { useMediaQuery } from 'react-responsive';
import useIsRtl from '../../../../../../app/helpers/isRtl';

const ICON_PLAY = '/assets/svg/pauseRound.svg';
const ICON_PAUSE = '/assets/svg/pauseVideo.svg';
const doubleQuoteLeft = '/icons/doubleQuoteLeft.svg';
const doubleQuoteRight = '/icons/doubleQuoteRight.svg';
const muteVid = '/assets/svg/muted.svg';
const unmuteVid = '/assets/svg/unmuted.svg';

const SECTION_ID = 0;
const joinUrl = (base, file) => {
  if (!base || !file) return null;
  const b = base.endsWith('/') ? base : base + '/';
  return b + String(file).replace(/^\/+/, '');
};

const isVideoPath = (p = '') => /\.(mp4|webm|ogv|m4v|mov)(\?.*)?$/i.test(p);

const pickMedia = (item) => {
  const c1 = joinUrl(item?.blobUrl, item?.media1) || item?.media1 || '';
  const c2 = joinUrl(item?.blobUrl, item?.media2) || item?.media2 || '';
  const candidates = [c1, c2].filter(Boolean);
  const video = candidates.find(isVideoPath) || null;
  const image = candidates.find((c) => !isVideoPath(c)) || null;
  return { video, image };
};

const HomeSlider = ({
  currentSection,
  slideIndex,
  item,
  currentSlide,
  setPauseVideo,
  pauseVideo,
}) => {
  useDeafModeAutoMute();

  const isRtl = useIsRtl();
  const isMobile = useMediaQuery({ maxWidth: 1000 });
  const dispatch = useDispatch();
  const volumeState = useSelector((state) => state.volume);
  const [pauseOnFirstRender, setPauseOnFirstRender] = useState(false);
  const { video, image } = useMemo(() => pickMedia(item), [item]);

  const isActive = currentSection === SECTION_ID && currentSlide === slideIndex;

  const handleTogglePause = () => {
    if (setPauseVideo) setPauseVideo((prev) => !prev);
  };

  useEffect(() => {
    if (video)
      setTimeout(() => {
        setPauseOnFirstRender(true);
      }, 5000);
  }, [video]);

  return (
    <div className={styles['slide-one']}>
      {item?.withHue ? <div className={styles['hue']} /> : null}
      <div
        className={`${styles['actions-container']} ${isRtl ? styles['actions-rtl'] : ''}`}
      >
        {isMobile ? (
          <button
            className={styles['pause-play-btn']}
            onClick={handleTogglePause}
          >
            <img src={pauseVideo ? ICON_PLAY : ICON_PAUSE} alt="" />
          </button>
        ) : null}

        {video ? (
          <button
            className={styles['mute-play-btn']}
            onClick={() => {
              dispatch(setVolume(volumeState === 'on' ? 'off' : 'on'));
            }}
          >
            <img src={volumeState === 'off' ? muteVid : unmuteVid} alt="" />
          </button>
        ) : null}
      </div>
      <LazyVideo
        src={video}
        isPaused={!isActive}
        isLooped={pauseOnFirstRender}
      />
      {image ? (
        <img
          className={styles.media}
          src={image}
          alt={item?.title || 'slide'}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
          }}
        />
      ) : null}
      {item?.slideType === 1 ? (
        <div className={styles['content']}>
          <div className={styles['container']}>
            <div className={styles['students-info']}>
              <img
                className={styles['left-quotes']}
                src={doubleQuoteLeft}
                alt="dubai police"
                loading="lazy"
              />
              <img
                className={styles['right-quotes']}
                src={doubleQuoteRight}
                alt="dubai police"
                loading="lazy"
              />
              <div className={styles['right-border']} />
              <div className={styles['left-border']} />
              <div
                className={styles.textContainer}
                style={{ textAlign: 'center' }}
              >
                <Text
                  title={item?.title}
                  variant="text-bold-italic-40"
                  className={styles.text}
                  isTranslated={false}
                  style={{ whiteSpace: 'pre-line' }}
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={styles['headings-container']}>
          <Text
            title={item?.title}
            variant="text-bold-italic-50"
            className={styles['titleWrap']}
          />
          <HtmlTag title={item?.description} variant="text-regular-20" />
        </div>
      )}
    </div>
  );
};

export default HomeSlider;
